export default "__VITE_ASSET__Udb0yyiu__"